import { useTranslation } from 'react-i18next';
import { ActionBar, SplitButton, iconWhatsapp, useSnackbar } from '@sauda/ui/kit';
import { whatsappLink } from '../../lib/share-text.js';
import type { ShareInfo } from '../../lib/types.js';

/** Share on WhatsApp as the docked action; copy the link or the message, or the phone's own share sheet. */
export function SharePanel({ share }: { share: ShareInfo }) {
  const { t } = useTranslation();
  const snack = useSnackbar();
  const canShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function';
  const copy = (what: 'link' | 'message') => {
    void navigator.clipboard?.writeText(what === 'link' ? share.link : share.text);
    snack({ text: t(what === 'link' ? 'property.linkCopied' : 'property.messageCopied') });
  };
  return (
    <>
      <p className="k-t-label-sm k-muted k-wrap-anywhere" data-testid="property-link">
        {share.link}
      </p>
      <ActionBar label={t('property.share')}>
        <SplitButton
          label={t('property.shareWhatsapp')}
          icon={iconWhatsapp}
          menuLabel={t('property.shareMore')}
          onClick={() => window.open(whatsappLink(share.text), '_blank', 'noopener')}
          items={[
            { key: 'link', label: t('property.copyLink'), onSelect: () => copy('link') },
            { key: 'message', label: t('property.copyMessage'), onSelect: () => copy('message') },
            ...(canShare
              ? [
                  {
                    key: 'other',
                    label: t('property.shareOther'),
                    onSelect: () =>
                      void navigator.share({
                        title: share.title,
                        text: share.text,
                        url: share.link,
                      }),
                  },
                ]
              : []),
          ]}
        />
      </ActionBar>
    </>
  );
}
